<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Email Gateways</p>
        <button
          v-if="!loading"
          @click="showEditGateway = true"
          class="bg-primary text-white px-3 py-1 text-sm rounded-md"
        >
          Edit Email Gateway
        </button>
      </div>
      <div class="p-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showEmailEditSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ edit_success }}
          </div>
        </transition>
        <ve-table :columns="columns" :table-data="tableData" />
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- Edit -->
    <EditGateway
      @close="handleClose"
      :showEditGateway="showEditGateway"
      @closeOnSuccess="handleCloseOnSuccess"
      :data="tableData[0]"
      :emailTemplates="emailTemplates"
    ></EditGateway>

    <EmailTemplates
      :emailTemplatesList="emailTemplatesList"
      :emailVariables="emailVariables"
      :loading="loading"
      :loadingTemplates="loadingTemplates"
      @updateEmailTemplatesList="updateEmailTemplateList"
    ></EmailTemplates>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import EditGateway from "@/components/AdminSetups/email/editGateway.vue";
import EmailTemplates from "@/components/AdminSetups/email/emailTemplates.vue";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "Emails",
  components: { Loader, EditGateway, EmailTemplates },
  data() {
    return {
      showEditGateway: false,
      loading: false,
      loadingTemplates: false,
      showEmailEditSuccess: false,
      edit_success: null,
      showPass: false,
      get_error: null,
      emailTemplates: null,
      emailTemplatesList: null,
      emailVariables: null,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Host",
          key: "a",
          title: "Host",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => {
            return (
              <p
                on-click={() => (this.showEditGateway = true)}
                class="text-blue-500 cursor-pointer"
              >
                {row.Host}
              </p>
            );
          },
        },
        { field: "Port", key: "b", title: "Port" },
        {
          field: "Username",
          key: "c",
          title: "Username",
          headerAlign: "left",
          align: "left",
          width: 200,
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Username"}
              width="300"
              trigger="hover"
              content={row.Username}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Username}
              </p>
            </el-popover>
          ),
        },
        {
          field: "From",
          key: "f",
          title: "Sender",
          headerAlign: "left",
          width: 200,
          align: "left",

          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Sender"}
              width="300"
              trigger="hover"
              content={row.From}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.From}
              </p>
            </el-popover>
          ),
        },
        {
          field: "OrganizationLink",
          key: "OrganizationLink",
          title: "Organization Link",
          headerAlign: "left",
          align: "left",

          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Organization Link"}
              width="300"
              trigger="hover"
              content={row.OrganizationLink}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.OrganizationLink}
              </p>
            </el-popover>
          ),
        },
        {
          field: "AdminLink",
          key: "fffd",
          title: "Admin Link",
          headerAlign: "left",
          align: "left",

          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Admin Link"}
              width="300"
              trigger="hover"
              content={row.AdminLink}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.AdminLink}
              </p>
            </el-popover>
          ),
        },
        {
          field: "ReceiveError",
          key: "g",
          title: "ReceiveError",
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created() {
    this.getEmailGateways();
    this.getEmailTemplates();
  },
  methods: {
    handleClose() {
      this.showEditGateway = false;
    },
    handleCloseOnSuccess(message) {
      this.edit_success = message;
      this.showEditGateway = false;
      this.showEmailEditSuccess = true;
      setTimeout(() => {
        this.showEmailEditSuccess = false;
      }, 3000);
      this.getEmailGateways();
    },
    getEmailGateways() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`setup/v1/request`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData.push(response.data.Data.emailSetup);
            this.emailTemplates = this.tableData[0].defaultEmailTemplates;
            //console.log(this.emailTemplates)
            this.$store.commit("setLicencePricing", response.data.Data.licence);
            this.emailTemplatesList = response.data.Data.emailTemplates;
            this.emailVariables = response.data.Data.emailVariables;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },
    updateEmailTemplateList() {
      this.loadingTemplates = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`setup/v1/request`, options).then(
        (response) => {
          this.loadingTemplates = false;
          if (response.data.StatusCode == 200) {
            this.emailTemplatesList = response.data.Data.emailTemplates;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loadingTemplates = false;
          this.get_error = error.message;
        }
      );
    },
    getEmailTemplates() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(
          `setup/email/template/${this.$ApiVersion}/request`,

          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.emailTemplates = response.data.Data;
              //console.log(this.emailTemplates)
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
  },
};
</script>
